var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnouncements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.928,
    height: 28.931,
    viewBox: "0 0 28.928 28.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bullhorn-solid",
    d: "M27.12,1.755A1.812,1.812,0,0,0,24.029.473L21.566,2.942A14.463,14.463,0,0,1,11.339,7.179H3.616A3.619,3.619,0,0,0,0,10.8v5.424a3.619,3.619,0,0,0,3.616,3.616v7.232a1.806,1.806,0,0,0,1.808,1.808H9.04a1.806,1.806,0,0,0,1.808-1.808V19.835h.492a14.463,14.463,0,0,1,10.226,4.237l2.463,2.463a1.812,1.812,0,0,0,3.091-1.283V16.92a3.712,3.712,0,0,0,1.808-3.413,3.712,3.712,0,0,0-1.808-3.413ZM23.5,6.089V20.926a18.072,18.072,0,0,0-12.164-4.706h-.492V10.8h.492A18.072,18.072,0,0,0,23.5,6.089Z",
    transform: "translate(0 0.056)",
    fill: "#0f445a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncements);
export default __webpack_public_path__ + "static/media/announcements.c1242ef8271c5fb3d31e6a5d3a286b5e.svg";
export { ForwardRef as ReactComponent };